import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Button from '../../components/ui/Button';
import CourseCard from './components/CourseCard';
import Icon from '../../components/AppIcon';

const CategoryCourses = () => {
  const { type, level } = useParams();
  const navigate = useNavigate();

  // Course data - same as main page
  const courses = [
    {
      id: 1,
      title: 'Chinese Language 101',
      description: 'Perfect for complete beginners. Learn basic Mandarin, essential phrases, and cultural basics.',
      type: '101',
      level: 'beginner',
      icon: 'BookOpen',
      instructor: 'Li Wei',
      duration: '8 weeks • 24 hours',
      students: 2547,
      rating: 5,
      reviews: 489,
      price: 99,
    },
    {
      id: 2,
      title: 'Intermediate Conversational Chinese',
      description: 'Build confidence in everyday conversations, expand vocabulary, and improve pronunciation.',
      type: '101',
      level: 'intermediate',
      icon: 'MessageCircle',
      instructor: 'Wang Chen',
      duration: '10 weeks • 30 hours',
      students: 1823,
      rating: 5,
      reviews: 324,
      price: 129,
    },
    {
      id: 6,
      title: 'Advanced Mandarin Mastery',
      description: 'Achieve fluency with advanced grammar, idioms, literature analysis, and native-level proficiency.',
      type: '101',
      level: 'advanced',
      icon: 'Brain',
      instructor: 'Prof. Ma Wei',
      duration: '14 weeks • 45 hours',
      students: 654,
      rating: 5,
      reviews: 189,
      price: 179,
    },
    {
      id: 4,
      title: 'HSK Examination Prep',
      description: 'Comprehensive preparation for HSK certification tests with practice exams and expert tips.',
      type: '101',
      level: 'certification',
      icon: 'Award',
      instructor: 'Liu Ming',
      duration: '6 weeks • 20 hours',
      students: 3124,
      rating: 5,
      reviews: 612,
      price: 89,
    },
    {
      id: 3,
      title: 'Intermediate Business Chinese 1',
      description: 'The MOOC of Intermediate Business Chinese is designed for Chinese language learners who have reached HSK level 3.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Briefcase',
      instructor: 'Shanghai Jiaotong University',
      duration: '5 weeks • 22 hours',
      students: 8500,
      rating: 5,
      reviews: 1234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/intermediate-business-chinese-1',
      category: 'mooc',
    },
    {
      id: 7,
      title: 'Chinese for HSK1',
      description: 'Official Coursera course by Peking University. Master fundamental Chinese language skills and pass the HSK1 certification exam.',
      type: 'mooc',
      level: 'beginner',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '7 weeks • 15 hours',
      students: 45000,
      rating: 5,
      reviews: 8234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-1',
      category: 'mooc',
    },
    {
      id: 8,
      title: 'Chinese for HSK2',
      description: 'Welcome to HSK Level 2 course by Peking University! Master 150+ new vocabularies, 62 grammar points.',
      type: 'mooc',
      level: 'beginner',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 34 hours',
      students: 28000,
      rating: 5,
      reviews: 4156,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-2',
      category: 'mooc',
    },
    {
      id: 9,
      title: 'Chinese for HSK 3 Part 1',
      description: 'Official Coursera course by Peking University. Advance to upper-intermediate proficiency with complex grammar and conversational skills.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 15000,
      rating: 5,
      reviews: 2234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3',
      category: 'mooc',
    },
    {
      id: 10,
      title: 'Chinese for HSK 3 Part 2',
      description: 'Official Coursera course by Peking University. Complete HSK3 proficiency with advanced conversational and writing skills.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 12000,
      rating: 5,
      reviews: 1876,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3-part2',
      category: 'mooc',
    },
    {
      id: 11,
      title: 'Chinese for HSK 4',
      description: 'Official Coursera course by Peking University. Reach upper-intermediate proficiency with advanced vocabulary, complex writing, and professional communication.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 20 hours',
      students: 10000,
      rating: 5,
      reviews: 1543,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-4',
      category: 'mooc',
    },
    {
      id: 12,
      title: 'Chinese for HSK 5',
      description: 'Official Coursera course by Peking University. Achieve advanced proficiency with mastery of complex topics, professional settings, and cultural nuance.',
      type: 'mooc',
      level: 'advanced',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 22 hours',
      students: 7500,
      rating: 5,
      reviews: 1089,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk5',
      category: 'mooc',
    },
    {
      id: 13,
      title: 'Chinese for HSK 6',
      description: 'Official Coursera course by Peking University. Achieve mastery level proficiency with complete fluency in all contexts and native-level comprehension.',
      type: 'mooc',
      level: 'advanced',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 25 hours',
      students: 5000,
      rating: 5,
      reviews: 723,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk-6',
      category: 'mooc',
    },
    // HSK Certification Preparation Courses
    {
      id: 701,
      title: 'Chinese for HSK1',
      description: 'Official Coursera course by Peking University. Master fundamental Chinese language skills and pass the HSK1 certification exam.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 15 hours',
      students: 45000,
      rating: 5,
      reviews: 8234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-1',
      category: 'mooc',
    },
    {
      id: 702,
      title: 'Chinese for HSK2',
      description: 'Welcome to HSK Level 2 course by Peking University! Master 150+ new vocabularies, 62 grammar points.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 34 hours',
      students: 28000,
      rating: 5,
      reviews: 4156,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-2',
      category: 'mooc',
    },
    {
      id: 703,
      title: 'Chinese for HSK 3 Part 1',
      description: 'Official Coursera course by Peking University. Advance to upper-intermediate proficiency with complex grammar and conversational skills.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 15000,
      rating: 5,
      reviews: 2234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3',
      category: 'mooc',
    },
    {
      id: 704,
      title: 'Chinese for HSK 3 Part 2',
      description: 'Official Coursera course by Peking University. Complete HSK3 proficiency with advanced conversational and writing skills.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 12000,
      rating: 5,
      reviews: 1876,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3-part2',
      category: 'mooc',
    },
    {
      id: 705,
      title: 'Chinese for HSK 4',
      description: 'Official Coursera course by Peking University. Reach upper-intermediate proficiency with advanced vocabulary, complex writing, and professional communication.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 20 hours',
      students: 10000,
      rating: 5,
      reviews: 1543,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-4',
      category: 'mooc',
    },
    {
      id: 706,
      title: 'Chinese for HSK 5',
      description: 'Official Coursera course by Peking University. Achieve advanced proficiency with mastery of complex topics, professional settings, and cultural nuance.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 22 hours',
      students: 7500,
      rating: 5,
      reviews: 1089,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk5',
      category: 'mooc',
    },
    {
      id: 707,
      title: 'Chinese for HSK 6',
      description: 'Official Coursera course by Peking University. Achieve mastery level proficiency with complete fluency in all contexts and native-level comprehension.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 25 hours',
      students: 5000,
      rating: 5,
      reviews: 723,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk-6',
      category: 'mooc',
    },
  ];

  const levelLabels = {
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    certification: 'Certification Preparation',
  };

  const typeLabels = {
    '101': '101 Courses',
    'mooc': 'MOOC Programs',
  };

  const filteredCourses = courses.filter(
    (course) => course.type === type && course.level === level
  );

  const handleEnroll = (courseId) => {
    const course = courses.find((c) => c.id === courseId);
    if (course.category === 'mooc' && course.courseraUrl) {
      window.open(course.courseraUrl, '_blank');
    }
  };

  const handleViewDetails = (courseId) => {
    navigate(`/online-learning/course/${courseId}`);
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-primary/5 border-b border-border">
        <div className="max-w-[1200px] mx-auto px-6">
          <button
            onClick={() => navigate('/online-learning')}
            className="flex items-center gap-2 text-primary hover:underline mb-4 font-medium text-sm"
          >
            <Icon name="ChevronLeft" size={18} />
            Back to All Courses
          </button>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            {typeLabels[type]} - {levelLabels[level]}
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Explore all {levelLabels[level].toLowerCase()} courses in the {typeLabels[type].toLowerCase()} program.
          </p>
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-16 bg-background">
        <div className="max-w-[1200px] mx-auto px-6">
          {filteredCourses.length > 0 ? (
            <>
              <div className="mb-8">
                <p className="text-muted-foreground">
                  Showing <span className="font-semibold text-foreground">{filteredCourses.length}</span> course{filteredCourses.length !== 1 ? 's' : ''}
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredCourses.map((course) => (
                  <CourseCard
                    key={course.id}
                    course={course}
                    onEnroll={handleEnroll}
                    onViewDetails={handleViewDetails}
                  />
                ))}
              </div>
            </>
          ) : (
            <div className="text-center py-16">
              <Icon name="BookOpen" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4 opacity-50" />
              <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                No courses available
              </h3>
              <p className="text-muted-foreground mb-6">
                There are currently no {levelLabels[level].toLowerCase()} courses in the {typeLabels[type].toLowerCase()} program.
              </p>
              <Button
                variant="default"
                onClick={() => navigate('/online-learning')}
              >
                Browse Other Courses
              </Button>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CategoryCourses;
